import { Content } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { createTitle } from "@/functions/createTitle";
import { case_study_helper } from "@/helpers/case_study_helper";

export default function CaseStudiesPage({ content }) {
  return (
    <>
      <Content items={content} />
    </>
  );
}

export async function getStaticProps() {
  const title = "Case Studies";

  return {
    props: {
      meta: { title: createTitle(title, "Recruitment Solutions") },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              { label: "Recruitment Solutions", href: getRoute("recruitment-solutions") },
              { label: title, href: getRoute("caseStudies") },
            ],
          },
        },
        {
          component: "Header",
          props: {
            className: "text-primary",
            title: { path: "page.caseStudies.component.Header.title", placeholder: title },
            description: { path: "page.caseStudies.component.Header.description" },
            img: { path: "page.caseStudies.component.Header.img" },
            variant: "50/50"
          },
        },
        {
          component: "CaseStudiesFeed",
          props: {
            items: case_study_helper.fetch(),
          },
        },
      ],
    },
  };
}
